// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"c56090a8","453":"6c7a1784","483":"373609b5","684":"5ff0de82","839":"968d70c8"}[chunkId] + ".chunk.js";
};